import { useQueryClient } from "@tanstack/react-query";
import { usePostQueriesByIdEntry } from "@web/api/query/query";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export function useSealSubmission(selo: string | null) {
	const navigate = useNavigate();
	const queryClient = useQueryClient();
	const [isValidating, setIsValidating] = useState(false);

	const queryEntry = usePostQueriesByIdEntry({
		mutation: {
			onSuccess: (data) => {
				navigate(`/consulta/${data.query.id}`);
			},
		},
	});

	const activeError = queryEntry.error;
	const isQrCodeNotFoundError =
		!!activeError &&
		typeof activeError === "object" &&
		"data" in activeError &&
		!!activeError.data &&
		typeof activeError.data === "object" &&
		"message" in activeError.data &&
		activeError.data.message === "QR code não encontrado";

	const confirmPhoto = async (imageSrc: string) => {
		if (navigator.vibrate) navigator.vibrate([30, 50, 30]);

		try {
			setIsValidating(true);

			const blobImage = await (await fetch(imageSrc)).blob();

			const form = new FormData();
			form.append("image", blobImage);

			const response = await queryEntry.mutateAsync({
				id: selo || "",
				data: {
					image: form.get("image") as File,
				},
			});

			queryClient.invalidateQueries({
				queryKey: ["consultations", response.query.id],
			});

			navigate(`/consulta/${response.query.id}`);
		} catch (error) {
			console.error(error);
		} finally {
			setIsValidating(false);
		}
	};

	return {
		isPending: queryEntry.isPending,
		isError: queryEntry.isError,
		error: activeError,
		isQrCodeNotFoundError,
		isValidating,
		confirmPhoto,
		reset: queryEntry.reset,
	};
}
